<script setup>
import '@campact/camper/cta/CmprModal';

import { ref, watch } from 'vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const modal = ref(undefined);
const emit = defineEmits(['update:visible']);

watch(() => props.visible, (visible) => {
  if (visible) {
    modal.value.show();
  } else {
    modal.value.close();
  }
});
</script>

<template>
  <cmpr-modal
    ref="modal"
    footeralign="left"
    @cmpr-modal-hidden="emit('update:visible', false)"
  >
    <slot name="content" />
    <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
    <footer slot="footer">
      <slot name="footer" />
    </footer>
  </cmpr-modal>
</template>
